import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { LuFileSearch } from 'react-icons/lu';
import { Button } from 'components/common';
import { Notice } from '../ComparisonResult';
import FileDrop, { fileProblem } from './FileDrop';

// Two files: the standard and the draft to check. A key remounts it empty after a start.
const DraftUploadForm = ({ busy, onSubmit }) => {
  const [standardFile, setStandardFile] = useState(null);
  const [file, setFile] = useState(null);

  const problems = [fileProblem(standardFile), fileProblem(file)].filter(Boolean);
  const ready = standardFile && file && problems.length === 0 && !busy;

  const submit = (e) => {
    e.preventDefault();
    if (ready) onSubmit({ standardFile, file });
  };

  return (
    <form onSubmit={submit} className="tw-flex tw-flex-col tw-gap-3" aria-label="Compare a draft">
      <FileDrop label="1. Standard file" hint="The PEB standard (or the version agreed earlier)"
        file={standardFile} onChange={setStandardFile} />
      <FileDrop label="2. Draft to check" hint="The draft from Sales / the customer — a signed or scanned PDF works too"
        file={file} onChange={setFile} />

      {problems.map((p) => <Notice key={p} tone="red">{p}</Notice>)}

      <Button type="submit" variant="primary" size="sm" leftIcon={LuFileSearch} loading={busy} disabled={!ready}>
        Compare
      </Button>
    </form>
  );
};

DraftUploadForm.propTypes = { busy: PropTypes.bool.isRequired, onSubmit: PropTypes.func.isRequired };

export default DraftUploadForm;
